var VolumePromotionLevel = /** @class */ (function () {
    function VolumePromotionLevel(obj, id) {
        if (id) {
            this.id = id;
        }
        this.from_quantity = obj.from_quantity;
        this.to_quantity = obj.to_quantity;
        this.percent_adjustment = obj.percent_adjustment;
    }
    Object.defineProperty(VolumePromotionLevel.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotionLevel.prototype, "FromQuantity", {
        get: function () {
            return this.from_quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotionLevel.prototype, "ToQuantity", {
        get: function () {
            return this.to_quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotionLevel.prototype, "PercentAdjustment", {
        get: function () {
            return this.percent_adjustment;
        },
        enumerable: false,
        configurable: true
    });
    return VolumePromotionLevel;
}());
export { VolumePromotionLevel };
export function createVolumePromotionLevel(obj, id) {
    return new VolumePromotionLevel(obj, id);
}
export function createVolumePromotionLevels(rawLevels) {
    var volumePromotionLevels = [];
    var rawAdjustmentLevelsData = rawLevels.data;
    for (var _i = 0, rawAdjustmentLevelsData_1 = rawAdjustmentLevelsData; _i < rawAdjustmentLevelsData_1.length; _i++) {
        var rawAdjustmentLevel = rawAdjustmentLevelsData_1[_i];
        var adjustmentLevel = createVolumePromotionLevel(rawAdjustmentLevel.attributes, rawAdjustmentLevel.id);
        volumePromotionLevels.push(adjustmentLevel);
    }
    return volumePromotionLevels;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/volumePromotionLevel/volumePromotionLevel.ts
// module id = 67
// module chunks = 0